export class CustomInstrumentList {
    constructor(mess) {
        this.Update(mess);
    }
    Update(mess) {
        this.id = mess.Id;
        this.name = mess.Name;
        this.destription = mess.Description;
        this.imageBytes = mess.RawBytes;
        this.langAliases = mess.Aliases;
        this.tradableIds = mess.TradableInstrumentId;
        this.type = mess.ListType;
    }
}
